import { css } from '@emotion/react';


export default $ => css`
  ${css(Object.entries($.sizes).map(([size, length]) => `
    .w-${size} { width: ${length} !important; }
    .h-${size} { height: ${length} !important; }
  `))}

  .mw-100 { max-width: 100% !important; }
  .mh-100 { max-height: 100% !important; }

  .min-vw-100 { min-width: 100vw !important; }
  .min-vh-100 { min-height: 100vh !important; }

  .vw-100 { width: 100vw !important; }
  .vh-100 { height: 100vh !important; }
`;
